module.exports = __webpack_public_path__ + "media/dog-personality-traits/leash-29578783.svg";